import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const airbyte = defineConnector({
  identifier: "airbyte",
  name: "Airbyte",
  tagLine: "Data integration platform",
  logo,
  protocol: "http",
  tags: ["data", "engineering"],
  defaultUrlPattern: ({ apiBaseUrl }) => domainToRegex(apiBaseUrl),
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: `${app.config.apiBaseUrl}/applications/token`,
        jsonBody: {
          client_id: app.config.clientId,
          client_secret: app.secret.clientSecret,
        },
      },
      extract: { from: "jsonPath", paths: ["access_token"] },
      apply: { kind: "header", scheme: "Bearer" },
    }),
  steps: [
    {
      title: "Create an Airbyte application",
      items: [
        {
          kind: "markdown",
          content:
            "In Airbyte, create an application for API access, then copy its client ID and client secret. Airbyte applications exchange these credentials for bearer tokens at the API token endpoint.",
        },
      ],
    },
    {
      title: "Enter your Airbyte details",
      items: [
        {
          kind: "baseUrl",
          label: "API base URL",
          required: true,
          defaultValue: "https://api.airbyte.com/v1",
          placeholder: "https://api.airbyte.com/v1",
          target: { kind: "configuration", field: "apiBaseUrl" },
          helperText:
            "Use your Airbyte API base URL, including the API version path when required.",
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "configuration", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "secrets", field: "clientSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ apiBaseUrl }) => ({
      url: `${apiBaseUrl}/workspaces`,
      expectedStatus: [200, 403],
    }),
  },
});
